import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    link: {
        color: 'black',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    zipAutocomplete: {
        '& .MuiAutocomplete-endAdornment': {
            display: 'none',
        },
    },
    guaranteedTimeTextboxWarning: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${theme.palette.warning.main} !important`,
        },
    },
    gpsConfirmAlert: {
        '& .MuiAlert-icon': {
            display: 'none',
        },
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important'
        }
    },
}))

export default useStyles
